import { render, staticRenderFns } from "./ApplicationFlowUnderReview.vue?vue&type=template&id=ad545fa4&scoped=true&"
import script from "./ApplicationFlowUnderReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowUnderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad545fa4",
  null
  
)

export default component.exports